var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_box"},[_vm._v(" 放图片 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }